import { styled } from '@mui/material'

export function ForwardMenuItemsWrapper({
  children,
}: {
  children: JSX.Element[]
}) {
  return (
    <Root>
      <Grid>{children}</Grid>
    </Root>
  )
}

const Root = styled('div')`
  height: 100%;
  padding: 16px 12px;
  overflow: hidden auto;
`

const Grid = styled('div')`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 4px;
  row-gap: 4px;
`
